export class Bar {
  constructor(svg, svgAux = null) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
  }
  // VERTICAL BARS GROUP
  barsGroup(_this, allData, context) {
    allData.forEach((obj) => {
      if (
        !Object.prototype.hasOwnProperty.call(obj, "isShow") ||
        _this.Analytics["userSelections"][obj.isShow]
      ) {
        obj.showFields.forEach((field, i) => {
          if (
            obj.customNameBars[i] === "q_min" ||
            obj.customNameBars[i] === "q_max"
          ) {
            return;
          }
          const normalize = _this.Analytics["userSelections"]["normalizeQty"];
          let multipleFields = false;
          let fieldMulti = normalize
            ? `${obj.customNameBars[i]}Perc`
            : obj.customNameBars[i];

          if (Array.isArray(field)) {
            multipleFields = field.every(
              (f) => _this.Analytics["userSelections"][f],
            );
          }
          if (Array.isArray(obj.yFields[i])) {
            let isShowData =
              _this.Analytics["userSelections"][obj.multipleYField];

            fieldMulti = isShowData ? obj.yFields[i][0] : obj.yFields[i][1];
          }
          if (
            (obj.customNameBars[i] &&
              _this.Analytics["userSelections"][field]) ||
            multipleFields
          ) {
            context.svg[obj.customNameBars[i]]
              .selectAll("rect")
              .data(obj.data)
              .join(
                function(enter) {
                  return enter
                    .append("rect")
                    .attr("y", (d) => context.svg.y(d[obj.yFields[i]]));
                },
                function(update) {
                  return update
                    .attr("y", (d) => {
                      if (!Number.isNaN(d[obj.yFields[i]])) {
                        const stackedBar2 =
                          obj.customNameBars[i].includes("stacked2Bar") &&
                          d[obj.yFields[i]] + d[obj.yFields[i - 1]];
                        const stackedBar1 =
                          obj.customNameBars[i].includes("stacked1Bar") &&
                          d[obj.yFields[i]];

                        const yFieldIndex =
                          context.heightResizeZoom && !_this.isPrices
                            ? fieldMulti
                            : obj.yFields[i];

                        const yValue = stackedBar2
                          ? stackedBar2
                          : stackedBar1
                          ? stackedBar1
                          : d[yFieldIndex];

                        return context.svg.y(yValue);
                      }
                    })
                    .attr("height", (d) => {
                      if (!Number.isNaN(d[obj.yFields[i]])) {
                        return !obj.isElementZero[i] ||
                          !context.heightResizeZoom
                          ? 4
                          : Math.abs(
                              context.svg.y(0) -
                                context.svg.y(
                                  d[
                                    Array.isArray(obj.yFields[i])
                                      ? fieldMulti
                                      : obj.yFields[i]
                                  ],
                                ),
                            );
                      }
                    });
                },
                function(exit) {
                  return exit.remove();
                },
              );
          }
        });
      }
    });
  }

  // VERTICAL BARS GROUP OLD
  barsGroupOld(_this, allData, context) {
    allData.forEach((obj) => {
      obj.showFields.forEach((field, i) => {
        if (obj.customNameBars[i] && _this[field]) {
          context.svg[obj.customNameBars[i]]
            .selectAll("rect")
            .data(obj.data)
            .join(
              function(enter) {
                return enter
                  .append("rect")
                  .attr("y", (d) => context.svg.y(d[obj.yFields[i]]));
              },
              function(update) {
                update
                  .attr("y", (d) => {
                    if (!Number.isNaN(d[obj.yFields[i].high])) {
                      return context.svg.y(d[obj.yFields[i].high]);
                    } else if (!Number.isNaN(d[obj.yFields[i]])) {
                      const stackedBar2 =
                        obj.customNameBars[i].includes("stacked2Bar") &&
                        d[obj.yFields[i]] + d[obj.yFields[i - 1]];
                      const stackedBar1 =
                        obj.customNameBars[i].includes("stacked1Bar") &&
                        d[obj.yFields[i]];

                      const yFieldIndex = obj.yFields[i];

                      const yValue = stackedBar2
                        ? stackedBar2
                        : stackedBar1
                        ? stackedBar1
                        : d[yFieldIndex];
                      return context.svg.y(yValue);
                    }
                  })
                  .attr("height", (d) => {
                    if (
                      !Number.isNaN(d[obj.yFields[i]?.high]) &&
                      !Number.isNaN(d[obj.yFields[i]?.low])
                    ) {
                      return Math.abs(
                        context.svg.y(d[obj.yFields[i].low]) -
                          context.svg.y(d[obj.yFields[i].high]),
                      );
                    } else if (!Number.isNaN(d[obj.yFields[i]])) {
                      return !obj.isElementZero[i] || !context.heightResizeZoom
                        ? 4
                        : Math.abs(
                            context.svg.y(0) - context.svg.y(d[obj.yFields[i]]),
                          );
                    }
                  });
              },
              function(exit) {
                return exit.remove();
              },
            );
        }
      });
    });
  }

  // CANDLES
  candlesOld(_this, allData, context) {
    allData.forEach((obj) => {
      obj.customNameBars.forEach((bar) => {
        context.svg[bar]
          .selectAll("rect")
          .data(obj.data)
          .join(
            function(enter) {
              return enter.append("rect").attr("y", (d) => {
                if (bar === "stick") {
                  context.svg.y(Math.max(d.open, d.close));
                }
              });
            },
            function(update) {
              update
                .attr("y", (d) => {
                  if (bar === "candle") {
                    return context.svg.y(Math.max(d.open, d.close));
                  } else if (bar === "stick") {
                    return context.svg.y(d.high);
                  } else {
                    return context.svg.y(Math.min(d.open, d.close));
                  }
                })
                .attr("height", (d) => {
                  if (bar === "candle") {
                    return Math.abs(
                      context.svg.y(Math.min(d.open, d.close)) -
                        context.svg.y(Math.max(d.open, d.close)),
                    );
                  } else if (bar === "stick") {
                    return Math.max(
                      0.0000001,
                      context.svg.y(Math.max(d.open, d.close)) -
                        context.svg.y(d.high),
                    );
                  } else {
                    return Math.max(
                      0.0000001,
                      context.svg.y(d.low) -
                        context.svg.y(Math.min(d.open, d.close)),
                    );
                  }
                });
            },
            function(exit) {
              return exit.remove();
            },
          );
      });
    });
  }
  // MULTIPLE STACKED BARS
  multipleStackedBarsZoom(_this, allData, context) {
    allData.forEach((obj) => {
      if (
        !Object.prototype.hasOwnProperty.call(obj, "isShow") ||
        _this.Analytics["userSelections"][obj.isShow]
      ) {
        obj.yFields.forEach((yField, fieldIndex) => {
          if (obj.customNameBars[fieldIndex]) {
            context.svg[obj.customNameBars[fieldIndex]]
              .selectAll("rect")
              .data(obj.data)
              .join(
                function(enter) {
                  return enter
                    .append("rect")
                    .attr("y", (d) => context.svg.y(d[yField]));
                },
                function(update) {
                  return update
                    .attr("y", (d) => {
                      let accumulated = 0;
                      if (!Number.isNaN(d[yField])) {
                        const isValueNegative = d[yField] < 0;
                        for (let j = 0; j < fieldIndex; j++) {
                          const value = +d[obj.yFields[j]];

                          if (isValueNegative && value < 0) {
                            accumulated += value;
                          } else if (!isValueNegative && value > 0) {
                            accumulated += value;
                          }
                        }
                        const baseValue = accumulated;
                        const currentValue = +d[yField];
                        const yBase = context.svg.y(baseValue);
                        const yTop = context.svg.y(baseValue + currentValue);
                        return Math.min(yBase, yTop);
                      }
                    })
                    .attr("height", (d) => {
                      const yValue = d[yField];
                      if (!Number.isNaN(yValue)) {
                        const height = Math.abs(
                          context.svg.y(0) - context.svg.y(yValue),
                        );
                        return height;
                      }
                    });
                },
                function(exit) {
                  return exit.remove();
                },
              );
          }
        });
      }
    });
  }
}
